import React from 'react'
import cn from 'classnames'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

export default function Block(props) {
	const error = props.error || false;
		return (
			<Grid container className={cn("block-container", {'block-error': error})}>
			{!!props.onClick
				?
				<Grid container style={{marginBottom: '25px'}}>
					<Typography variant="h6" className="pointer" onClick={props.onClick}>{props.title}</Typography>
				</Grid>
				:
				<Grid container style={{marginBottom: '25px'}}>
					<Typography variant="h6">{props.title}</Typography>
				</Grid>
			}
			<Grid container className={props.contClassname}>
				{props.children}
			</Grid>
			{error && 
				<Grid container justify="flex-end">
					<Typography color="error">{props.errorMsg}</Typography>
				</Grid>
			}
		</Grid>
	)
}